// extracted by mini-css-extract-plugin
export default {"carouselButton":"styles_carousel-button_XHfKU","active":"styles_active_RYtKB"};